import { Anchor, Flex } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';
import { RALLIT_URL } from '../../../../../constants/urls';
import { eventNames } from '../../../../../utils/GTM/eventNames';
import { useTrackMixpanelEvent } from '../../../../../utils/GTM/useTrackMixpanelEvent';
import { IconRallit } from '../../../../layout/Header';
import { SettingSection } from '../common/SettingSection';

export const CareerSection = () => {
  const { t } = useTranslation();
  const { trackMixpanelEvent } = useTrackMixpanelEvent();

  const handleClick = () => {
    trackMixpanelEvent(eventNames.CLICK_MANAGE_MYCAREER, { spot: 'account' });
  };

  return (
    <Anchor href={RALLIT_URL.RALLIT_PROFILE_LIST()} target="_blank" w="100%">
      <SettingSection.Button
        title={t('MY 커리어 관리')}
        description={t('내 커리어 이력을 기록해보세요!')}
        onClick={handleClick}
        right={
          <Flex p={10} bg="gray.1" css={{ borderRadius: 8 }} align="center" justify="center">
            <IconRallit />
          </Flex>
        }
      />
    </Anchor>
  );
};
